import { styled, Box } from "@mui/material";

const layoutBoxProps = ["width", "dynamicBackground", "background", "widthSidebar", "rtl", "isOpen"];

export const Main = styled(Box, {
  shouldForwardProp: (prop) => !layoutBoxProps.includes(prop),
})(({ dynamicBackground, background }) => ({
  minHeight: "100vh",
  backgroundColor: dynamicBackground ? dynamicBackground : background,
  paddingBottom: "40px",
}));

export const LayoutWrapper = styled(Box, {
  shouldForwardProp: (prop) => !["background", "dynamicBackground"].includes(prop),
})(({ background, dynamicBackground }) => ({
  backgroundColor: dynamicBackground ? dynamicBackground : background,
}));
